<template>
    <div class="header-component-container" :style="headerStyle">
        <div class="container-content">
            <!-- logo -->
            <div class="logo-box">
                <img src="//cdn1.mimoprint.com/c-website/image/front/pc-logo.png" />
            </div>

            <!-- 类列表 -->
            <div class="classify-box">
                <div
                    class="w-btn classify-item"
                    v-for="item in showProductList"
                    :key="item.cateId"
                    v-html="item.cateName"
                    :class="{ 'active': item.cateId == activeClassify }"
                    @click=" typeEv(item)"
                ></div>
            </div>

            <!-- 菜单 -->
            <div class="menus-container">
                <div class="menus-header"><svg @click="toOpenWindon(conterUrl)" t="1612688858843" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2229" width="32" height="32"><path d="M512 84.329412a425.923765 425.923765 0 0 1 302.471529 125.199059A426.044235 426.044235 0 0 1 939.640471 512a425.923765 425.923765 0 0 1-125.168942 302.471529A426.044235 426.044235 0 0 1 512 939.640471a425.923765 425.923765 0 0 1-302.471529-125.168942A426.044235 426.044235 0 0 1 84.359529 512 425.923765 425.923765 0 0 1 209.528471 209.528471 426.044235 426.044235 0 0 1 512 84.359529m0-58.819764C243.290353 25.539765 25.539765 243.290353 25.539765 512S243.290353 998.460235 512 998.460235 998.460235 780.709647 998.460235 512 780.709647 25.539765 512 25.539765z" fill="#8a8a8a" p-id="2230"></path><path d="M387.312941 381.409882a124.687059 124.687059 0 1 0 249.374118 0 124.687059 124.687059 0 0 0-249.374118 0zM514.951529 545.882353c-123.663059 0-229.436235 80.956235-272.474353 195.523765a379.482353 379.482353 0 0 0 112.820706 77.522823 363.670588 363.670588 0 0 0 149.534118 31.894588c51.862588 0 102.219294-10.691765 149.534118-31.894588a381.349647 381.349647 0 0 0 122.096941-87.16047c1.656471-1.776941 3.192471-3.523765 4.818823-5.180236-46.08-106.616471-147.998118-180.705882-266.330353-180.705882z" fill="#8a8a8a" p-id="2231"></path></svg></div>
                <ul class="menus-list">
                    <li v-for="item in menusList" :key="item.name" v-html="item.name" @click="toOpenWindon(item)"></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

const conterUrl = 'https://100001196622.retail.n.weimob.com/saas/retail/100001196622/2260049622/user/member/center/vwif'

import { mapState } from "vuex"

export default {
    name: "",

    data() {
        return {
            activeClassify: "23525",

            conterUrl: conterUrl,

            menusList: [
                {   
                    url: conterUrl,
                    name: '个人中心'
                },
                {   
                    url: conterUrl,
                    name: '编辑作品',
                    ev: `$store.dispatch('makeEv')`
                },
                {   
                    url: 'https://100001196622.retail.n.weimob.com/saas/retail/100001196622/0/shop/index?id=12631219&storeId=2260049622',
                    name: '权益转移'
                },
            ],
        };
    },

    watch: {
        //
        $route:{
            handler(){
                if( this.$route.fullPath != "/" ){
                    this.activeClassify = null
                }
            },
            deep: true,
        },
    },

    computed: {
        //
        headerStyle() {
            return this.$route.fullPath == "/" ? `position: fixed;` : "";
        },

        ...mapState(["bannerList", "productList"]),
        
        showProductList(){
            return this.productList.filter((item)=>{ return item.wmProdBoList.length && item.wmProdBoList.filter( item=>{ return item.upState } ).length })
        },
    },

    methods: {
        //点击跳转
        toOpenWindon( item ){

            if( item.ev == `$store.dispatch('makeEv')` ){
                this.$store.dispatch('makeEv')()
                return
            }
            window.open( item.url )
        },

        //点击事件处理
        typeEv(item) {
            this.activeClassify = item.cateId

            let cateId = item.cateId

            this.$router.push("/")

            setTimeout(() => {
                this.$nextTick(()=>{
                    let dom = document.querySelector(`.group-content[data-name='${cateId}']`)
                    console.log( 'dom', dom )
                    dom && window.scrollTo({ 
                        top: dom.offsetTop - 110, 
                        behavior: "smooth" 
                    })
                })
            }, 16);
        }
    },

    created() {},
    mounted() {},
};
</script>

<style lang="less" scoped>
.header-component-container {
    width: 100%;
    height: 100px;
    border-bottom: 1px solid #ddd;
    user-select: none;

    background: #fff;
    z-index: 10;

    .container-content {
        width: 1024px;
        margin: 0 auto;
        height: 100%;

        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .logo-box {
        font-size: 0;
        img {
            width: 200px;
        }
    }
    .classify-box {
        display: flex;
        color: #777;
        align-items: center;
        width: 720px;
        justify-content: space-between;
        .classify-item {
            position: relative;
            padding: 0 6px;

            &.active {
                color: #813f44;
                &::after {
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 2px;
                    background: #813f44;
                    left: 0;
                    bottom: 0;
                    transform: translateY(6px);
                }
            }
        }
    }
    .menus-container{
        position: relative;
        &:hover .menus-list{
            display: inline-block;
        }
        .menus-header{
            cursor: pointer;
        }
        .menus-list{
            position: absolute;
            width: 90px;
            transform: translateX(-50%) translateY(100%) translateY(16px);
            left: 50%;
            text-align: center;
            bottom: 0;
            font-size: 14px;
            background: #fff;
            line-height: 38px;
            box-shadow: 0 0 2px 2px #ddd;
            padding: 10px 16px;
            border-radius: 3px;

            display: none;

            &:before {
                position: absolute;
                display: inline-block;
                top: 0;
                left: 50%;
                width: 0;
                height: 0;
                content: "";
                border-color: #fff #fff transparent transparent;
                border-style: solid;
                border-width: 4px;
                -webkit-box-shadow: 2px -2px 2px #ddd;
                box-shadow: 2px -2px 2px #ddd;
                -webkit-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
                transform: translateX(-50%) translateY(-50%) rotate(-45deg)
            }

            &:after {
                content: "";
                position: absolute;
                left: 0;
                top: -26px;
                width: 100%;
                height: 30px;
                background: transparent;
            }

            li{
                cursor: pointer;
            }
        }
    }
}
</style>